"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonToCIMSymbolLineObject = exports.JsonToCIMSymbolPointObject = void 0;
const CIMSymbol_1 = __importDefault(require("@arcgis/core/symbols/CIMSymbol"));
const cimSymbols = __importStar(require("./cim-symbols/index"));
const JsonToCIMSymbolPointObject = (name) => {
    const jsonObject = cimSymbols[name];
    if (jsonObject) {
        return new CIMSymbol_1.default({
            data: {
                type: "CIMSymbolReference",
                symbol: jsonObject,
            },
        });
    }
    else {
        console.log("Not found", name, "-", name);
        return new CIMSymbol_1.default({
            data: {
                type: "CIMSymbolReference",
                symbol: cimSymbols.not_found,
            },
        });
    }
};
exports.JsonToCIMSymbolPointObject = JsonToCIMSymbolPointObject;
const JsonToCIMSymbolLineObject = (name) => {
    const jsonObject = cimSymbols[name];
    if (jsonObject) {
        return new CIMSymbol_1.default({
            data: {
                type: "CIMSymbolReference",
                symbol: jsonObject,
            },
        });
    }
    else {
        console.log("Not found", name, "-", name);
        return new CIMSymbol_1.default({
            data: {
                type: "CIMSymbolReference",
                symbol: cimSymbols.not_found,
            },
        });
    }
};
exports.JsonToCIMSymbolLineObject = JsonToCIMSymbolLineObject;
